export const analyticsUrl = import.meta.env.VITE_ANALYTICS_URL;
export const adobeAnalyticsDataUrl = `${import.meta.env.VITE_BASE_SERVICES_URL!}/api/v1/vendor/param?name=analytics`;
